import { NavLink } from 'react-router-dom';

import {
  IconChevronDown as ChevronDownSVG,
  IconChevronUp as ChevronUpSVG,
  IconDataVisualization as DataVisualizationSVG,
} from '../../../core';
import { Menus, NavigationTab } from '../types';

import CompactTab from './CompactTab';

const DataVisualization = ({
  handleMenuCollapse,
  collapsedMenus,
  collapsedSubMenus,
  isMenuClosed,
  setIsMenuClosed,
}: NavigationTab) => {
  const link = '/data-visualization';

  if (isMenuClosed)
    return (
      <CompactTab
        menuOption={Menus.DATA_VISUALISATION}
        icon={<DataVisualizationSVG />}
        handleMenuCollapse={handleMenuCollapse}
        setIsMenuClosed={setIsMenuClosed}
        href={link}
      />
    );

  return (
    <li>
      <NavLink
        to={link}
        className={({ isActive }) => (isActive ? 'active' : '')}
        onClick={() => handleMenuCollapse(Menus.DATA_VISUALISATION)}
      >
        <>
          <div>
            <DataVisualizationSVG />
            <span>Data Visualizations</span>
          </div>
          {collapsedMenus.includes(Menus.DATA_VISUALISATION) ? (
            <ChevronDownSVG />
          ) : (
            <ChevronUpSVG />
          )}
        </>
      </NavLink>
      <ul
        className={`lvl-2 ${collapsedMenus.includes(Menus.DATA_VISUALISATION) ? 'collapsed' : ''}`}
      >
        <li>
          <NavLink
            to="/data-visualization/lines"
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={() => handleMenuCollapse('lines', true)}
          >
            <span>Lines</span>
            {collapsedSubMenus?.includes('lines') ? <ChevronDownSVG /> : <ChevronUpSVG />}
          </NavLink>
          <ul className={`lvl-3 ${collapsedSubMenus?.includes('lines') ? 'collapsed' : ''}`}>
            <li>
              <NavLink
                to="/data-visualization/lines/line-chart"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Line Chart</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/lines/area-chart"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Area Chart</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/lines/stacked-area-chart"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Stacked Area Chart</span>
              </NavLink>
            </li>
          </ul>
        </li>
        <li>
          <NavLink
            to="/data-visualization/bars"
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={() => handleMenuCollapse('bars', true)}
          >
            <span>Bars</span>
            {collapsedSubMenus?.includes('bars') ? <ChevronDownSVG /> : <ChevronUpSVG />}
          </NavLink>
          <ul className={`lvl-3 ${collapsedSubMenus?.includes('bars') ? 'collapsed' : ''}`}>
            <li>
              <NavLink
                to="/data-visualization/bars/chart-v"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Bar Chart - V</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/bars/chart-h"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Bar Chart - H</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/bars/grouped-bar-chart-v"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Grouped Bar Chart - V</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/bars/grouped-bar-chart-h"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Grouped Bar Chart - H</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/bars/stacked-bar-chart-v"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Stacked Bar Chart - V</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/bars/stacked-bar-chart-h"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Stacked Bar Chart - H</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/bars/lollipop-v"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Lollipop - V</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/bars/lollipop-h"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Lollipop - H</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/bars/grouped-lollipop-v"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Grouped Lollipop - V</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/bars/grouped-lollipop-h"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Grouped Lollipop - H</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/bars/stacked-lollipop-v"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Stacked Lollipop - V</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/bars/stacked-lollipop-h"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Stacked Lollipop - H</span>
              </NavLink>
            </li>{' '}
            <li>
              <NavLink
                to="/data-visualization/bars/funnel-chart"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Funnel Chart</span>
              </NavLink>
            </li>{' '}
            <li>
              <NavLink
                to="/data-visualization/bars/histogram"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Histogram</span>
              </NavLink>
            </li>
          </ul>
        </li>
        <li>
          <NavLink
            to="/data-visualization/maps"
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={() => handleMenuCollapse('maps', true)}
          >
            <span>Maps</span>
            {collapsedSubMenus?.includes('maps') ? <ChevronDownSVG /> : <ChevronUpSVG />}
          </NavLink>
          <ul className={`lvl-3 ${collapsedSubMenus?.includes('maps') ? 'collapsed' : ''}`}>
            <li>
              <NavLink
                to="/data-visualization/maps/choropleth"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Maps - Choropleth</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/maps/bubble"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Maps - Bubble</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/maps/spikes"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Map - Spikes</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/maps/scatter"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Map - Scatter</span>
              </NavLink>
            </li>
          </ul>
        </li>
        <li>
          <NavLink
            to="/data-visualization/tables"
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={() => handleMenuCollapse('tables', true)}
          >
            <span>Tables</span>
            {collapsedSubMenus?.includes('tables') ? <ChevronDownSVG /> : <ChevronUpSVG />}
          </NavLink>
          <ul className={`lvl-3 ${collapsedSubMenus?.includes('tables') ? 'collapsed' : ''}`}>
            <li>
              <NavLink
                to="/data-visualization/tables/heatmap"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Heatmap</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/tables/matrix"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Matrix</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/tables/punchcard"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Punchcard</span>
              </NavLink>
            </li>
          </ul>
        </li>
        <li>
          <NavLink
            to="/data-visualization/circulars"
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={() => handleMenuCollapse('circulars', true)}
          >
            <span>Circulars</span>
            {collapsedSubMenus?.includes('circulars') ? <ChevronDownSVG /> : <ChevronUpSVG />}
          </NavLink>
          <ul className={`lvl-3 ${collapsedSubMenus?.includes('circulars') ? 'collapsed' : ''}`}>
            <li>
              <NavLink
                to="/data-visualization/circulars/donut"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Donut Chart</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/circulars/polar"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Polar Area Chart</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/circulars/radar"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Radar Chart</span>
              </NavLink>
            </li>
          </ul>
        </li>
        <li>
          <NavLink
            to="/data-visualization/diagrams"
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={() => handleMenuCollapse('diagrams', true)}
          >
            <span>Diagrams</span>
            {collapsedSubMenus?.includes('diagrams') ? <ChevronDownSVG /> : <ChevronUpSVG />}
          </NavLink>
          <ul className={`lvl-3 ${collapsedSubMenus?.includes('diagrams') ? 'collapsed' : ''}`}>
            <li>
              <NavLink
                to="/data-visualization/diagrams/sankey"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Sankey Diagram</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/diagrams/treemap"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Treemap</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/diagrams/circle"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Circle Packing</span>
              </NavLink>
            </li>
          </ul>
        </li>
        <li>
          <NavLink
            to="/data-visualization/others"
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={() => handleMenuCollapse('others', true)}
          >
            <span>Others</span>
            {collapsedSubMenus?.includes('others') ? <ChevronDownSVG /> : <ChevronUpSVG />}
          </NavLink>
          <ul className={`lvl-3 ${collapsedSubMenus?.includes('others') ? 'collapsed' : ''}`}>
            <li>
              <NavLink
                to="/data-visualization/others/bubble"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Bubble Chart</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/others/box-plot-v"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Box Plot - V</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/others/box-plot-h"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Box Plot - H</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/others/violin-plot-v"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Violin Plot - V</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/others/violin-plot-h"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Violin Plot - H</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/others/line-and-stacked-bar"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Line &amp; Stacked Bar Chart</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/others/scatter-plot"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Scatter Plot</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/data-visualization/others/ribbon-chart"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                <span>Ribbon Chart</span>
              </NavLink>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  );
};

export default DataVisualization;
